import { Feature } from 'config/features';

import { getCheck24Namespace } from 'utility/Provide/Namespace/getCheck24Namespace';

import { BackendInformationFuncModule } from 'types/legacy/backendInformation';
import { GlobalNamespace } from 'types/legacy/namespace';

let backendInformationFunc: BackendInformationFuncModule | undefined =
    undefined;

export function getFeatureActive(name: Feature) {
    if (!backendInformationFunc) {
        backendInformationFunc = (getCheck24Namespace() as GlobalNamespace)
            .components.backendInformationFunc;
    }

    return backendInformationFunc.featureActive(name);
}
